module.exports = __webpack_public_path__ + "img/business_photo.55861d12.png";